import React, { useState, useEffect } from 'react';
import { Container } from 'react-bootstrap';
import PayPalBtn from './PayPalBtn';
import { ReqPost, ReqGet } from '../config/Requests';
import { dateFormatter } from '../helper/dateFormater';
import { confirmAlert } from 'react-confirm-alert';

import { Header, Footer } from './Container';
import { toast } from 'react-toastify';
function Subscription() {
	const [profile, setProfile] = useState({});
	const [subscriptionDetails, setSubscriptionDetails] = useState({});
	const [req, setReq] = useState(false);
	const [detailRequest, setDetailRequest] = useState(false);
	const [detailFailureRequest, setDetailFailureRequest] = useState(false);

	useEffect(() => {
		ReqGet('profile')
			.then(res => {
				setProfile(res.data);
				setReq(true);
			})
			.catch(err => {
				console.log(err.message);
			});

		ReqGet('subscription/detail')
			.then(res => {
				if (res.status === 200) {
					setSubscriptionDetails(res.data);
					setDetailRequest(true);
				} else {
					setDetailFailureRequest(true);
					setSubscriptionDetails(res.data);
				}
			})
			.catch(err => {
				console.log(err.message);
			});
	}, []);

	const paypalSubscribe = (data, actions) => {
		if (profile.user_type === 'member' || profile.user_type === 'Member') {
			return actions.subscription.create({
				plan_id: 'P-79S638834X9992059MBJBOHI',
			});
		} else if (profile.user_type === 'client') {
			let companySize = profile.client_profile.company_size;
			if (companySize === '1-100') {
				return actions.subscription.create({
					plan_id: 'P-88N151327H702771YMCUVRGI',
				});
			} else if (companySize === '101-500') {
				return actions.subscription.create({
					plan_id: 'P-30T79495AN7073023MCUVSOI',
				});
			} else if (companySize === '501-2000') {
				return actions.subscription.create({
					plan_id: 'P-4YM54740PL7058117MCUVTLQ',
				});
			} else if (companySize === '2001-5000') {
				return actions.subscription.create({
					plan_id: 'P-9R1666626F964720XMCUVUHQ',
				});
			} else if (companySize === '5001+') {
				return actions.subscription.create({
					plan_id: 'P-4LW82277TB0291038MCUVUZY',
				});
			}
		}
	};
	const paypalOnError = err => {
		console.log('Error');
		ReqPost('/subscription/rejected')
			.then(res => {
				console.log(res.data);
			})
			.catch(err => {
				alert(err.message);
			});
	};
	const paypalOnApprove = (data, detail) => {
		const subscriptionID = data.subscriptionID;
		ReqPost('/subscription/approved', { subscription_id: subscriptionID })
			.then(res => {
				toast.success(res.data.message);

				console.log(res.data);
				window.location.reload();
			})
			.catch(err => {
				alert(err.message);
			});
	};

	const confirmAction = (
		cb,
		title = 'Confirmation',
		msg = 'Are you sure you want to do that?'
	) => {
		confirmAlert({
			title: title,
			message: msg,
			buttons: [
				{
					label: 'Yes',
					onClick: () => cb(),
				},
				{
					label: 'No',
					onClick: () => {},
				},
			],
		});
	};

	const suspendSubscription = () => {
		ReqPost('/subscription/suspend')
			.then(res => {
				if (res.status === 200) {
					toast.success('Your subscription has been suspended successfully.');

					window.location.reload();
				}
			})
			.catch(err => {
				toast.error(err.message);
			});
	};

	const activeSubscription = () => {
		ReqPost('/subscription/activate')
			.then(res => {
				if (res.status === 200) {
					toast.success('Your subscription has been activated successfully.');

					window.location.reload();
				}
			})
			.catch(err => {
				toast.error(err.message);
			});
	};

	return (
		<Container fluid='true' className='p-0'>
			<Header type='member' />
			<Container>
				<div className='w100p'>
					<h6 className='red mt-5 text-align-center'>Subscription Details</h6>
					{detailFailureRequest === true && subscriptionDetails?.message ? (
						<div className='subscription_table mb-3'>
							{subscriptionDetails?.message}
						</div>
					) : null}
					{detailRequest === true && req === true && (
						<table className='table table-bordered'>
							<tbody>
								<tr>
									<td>
										<b>Name:</b>{' '}
										<span>
											{subscriptionDetails?.subscriber?.name?.given_name}{' '}
											{subscriptionDetails?.subscriber?.name?.surname}
										</span>
									</td>
									<td>
										<b>Email:</b>{' '}
										<span>
											{subscriptionDetails?.subscriber?.email_address}
										</span>
									</td>
								</tr>
								<tr>
									<td>
										<b>Last Payment:</b>{' '}
										<span>
											{
												subscriptionDetails?.billing_info?.last_payment?.amount
													?.value
											}{' '}
											{
												subscriptionDetails?.billing_info?.last_payment?.amount
													?.currency_code
											}
										</span>
									</td>
									<td>
										<b>Next Billing Time:</b>{' '}
										<span>
											{dateFormatter(
												subscriptionDetails?.billing_info?.next_billing_time
											)}
										</span>
									</td>
								</tr>
								<tr>
									<td>
										<b>Status:</b> <span>{profile.subscription_status}</span>
									</td>
									<td>
										<b>Date:</b>{' '}
										<span>
											{dateFormatter(subscriptionDetails?.update_time)}
										</span>
									</td>
								</tr>
							</tbody>
						</table>
					)}
					{req === true &&
					profile.is_subscribed === 0 &&
					profile.subscription_status === 'SUSPENDED' ? (
						<>
							<button
								className='btn btn-primary'
								onClick={() => confirmAction(activeSubscription)}
							>
								Active Subscription Plan
							</button>
						</>
					) : null}
					{req === true &&
					profile.is_subscribed === 1 &&
					profile.subscription_status === 'ACTIVE' ? (
						<button
							className='btn btn-warning ml-2'
							onClick={() => confirmAction(suspendSubscription)}
						>
							Suspend Subscription
						</button>
					) : null}
					{req === true &&
					profile.is_subscribed === 0 &&
					profile.subscription_status === 'PENDING' ? (
						<PayPalBtn
							amount='<amount>'
							currency='USD'
							createSubscription={paypalSubscribe}
							onApprove={paypalOnApprove}
							catchError={paypalOnError}
							onError={paypalOnError}
							onCancel={paypalOnError}
						/>
					) : null}
				</div>
			</Container>
			<Footer />
		</Container>
	);
}
export default Subscription;
